import {
    getBannerList,
    getBanner,
} from "../apis/api_banner.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list, showDt:'', brandId: 0},
    filtersPage: { mode: listMode.page },
    items: [],
    item: {},    
};

const getters = {
};

const mutations = {
    SET_BANNER_LIST(state, items){
        state.items = items;
    },

    SET_BANNER(state, payload) {
        state.item = payload
    },

    CLEAR_BANNER(state) {
        state.item = {};
    },
};

const actions = {

    async GET_BANNER_LIST({ state }, filters) {
        let params = { ...state.filters, ...filters };
        try {
            const response = await getBannerList(params);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_BANNER_LIST_PAGE({ state }, filters ) {
        let params = { ...state.filtersPage, ...filters };
        try {
            const response = await getBannerList(params);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_BANNER(context, id) {
        try {
            const response = await getBanner(id);
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },    
};

export default {mutations, state, actions, getters};